import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { IntlProvider } from "react-intl";
import { BrowserRouter as Router } from "react-router-dom";

import store from "./store";
import App from "./App";
import i18n from "./utils/initLocale";

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <IntlProvider locale={i18n.resolvedLanguage}>
        <App />
      </IntlProvider>
    </Provider>
  </Router>,
  document.getElementById("root")
);
